import { metric, toMeters } from 'components/AdminFloorPlan/components/MeasurementInput/measurement'
import ChildFilters from './ChildFilters'
import ParentFilter from './ParentFilter'
import css from './index.module.scss'
import { SAFEDISTANCING } from './viewFiltersCalculations'
import { ViewFilterChild, IViewFiltersData } from '@api'
type staticFilterProps = {
  isFiltered: boolean
  filters: ViewFilterChild[]
  viewFiltersData: IViewFiltersData
}
const SafeDistancingFilter = ({ filters, isFiltered, viewFiltersData }: staticFilterProps) => {
  return (
    <div>
      {filters?.map(({ filterId, children }: ViewFilterChild, filtersIndex: number) => (
        <div key={filterId + filtersIndex}>
          {children.length ? (
            <ParentFilter
              isFiltered={isFiltered}
              id={filterId}
              disabled={filterId === SAFEDISTANCING}
              viewFiltersData={viewFiltersData}>
              {children.map((id: string, childFilterIndex: number) => (
                <ChildFilters
                  key={id + childFilterIndex}
                  id={id}
                  viewFiltersData={viewFiltersData}
                />
              ))}
            </ParentFilter>
          ) : null}
        </div>
      ))}
    </div>
  )
}

export const SafeDistancingLegend = ({
  safeDistance,
  units,
}: {
  safeDistance: number | undefined
  units: string
}) => {
  return (
    <div className={css.container}>
      <div className={css.title}>Safe Distancing</div>
      <div className={css.content}>
        <div className={`${css.circle} ${css.blue}`} />
        <div className={css.blueText}>Safe Distance</div>
      </div>
      <div className={css.content}>
        <div className={`${css.circle} ${css.yellow}`} />
        <div className={css.yellowText}>
          {`Safe Distance Alert (under ${
            metric(units) && safeDistance ? toMeters(safeDistance).toFixed(1) : safeDistance
          }${metric(units) ? 'm' : 'ft'})`}
        </div>
      </div>
    </div>
  )
}
export default SafeDistancingFilter
